import { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';

import tailwindCSS from '../styles/tailwind.css?raw';

/**
 * Scopes Tailwind utilities via an open shadow root (createPortal).
 *
 * Do not render VBLeaflet (or any library that uses document.getElementById for
 * its mount target) inside this wrapper — see vbLeaflet.js module docs.
 *
 * The host uses `display: block; width: 100%` (not `display: contents`) so shadow
 * content gets a proper containing width. Portaled children are wrapped in a
 * full-width inner shell for the same reason.
 */
export const TailwindWrapper = ({ children }) => {
  const hostRef = useRef(null);
  const [shadowRoot, setShadowRoot] = useState(null);

  useEffect(() => {
    if (hostRef.current && !shadowRoot) {
      setShadowRoot(hostRef.current.attachShadow({ mode: 'open' }));
    }
  }, [shadowRoot]);

  useEffect(() => {
    if (shadowRoot) {
      if (!shadowRoot.querySelector('style[data-tailwind]')) {
        const style = document.createElement('style');
        style.setAttribute('data-tailwind', 'tailwind');
        style.textContent = tailwindCSS;
        shadowRoot.appendChild(style);
      }
    }
  }, [shadowRoot]);

  return (
    <div style={{ display: 'contents' }} ref={hostRef}>
      {shadowRoot && ReactDOM.createPortal(children, shadowRoot)}
    </div>
  );
};
